import { useTheme } from "@emotion/react";
import { colors } from "colors";
import Attachment from "components/attachments/Attachment";
import Loader from "components/react-lib/generic-ui/Loader";
import { collection, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import React from "react";
import { useCollection } from "react-firebase-hooks/firestore";

export default function ConversationAttachments({attachments}) {
  
  const theme = useTheme();

  return (
    <>
      {attachments.map((attachment) => (
        <Attachment 
          key={attachment.id}
          color={theme.palette.text.main}
          attachment={attachment}
        />
      ))}
    </>
  );

}
